// Hardcoded resume data
const resumeData = {
  name: "Asaf Lopez",
  fullname: "Asaf Eduardo Lopez Govea",
  title: "Senior Front-End Developer",
  contact: {
    location: "San Luis Potosí, México",
    email: "asaf.eduardo@gmail.com",
    phone: "+52 55 7346 9088",
    linkedin: "https://www.linkedin.com/in/asaf-lopez-govea"
  },
  hook: "A decade+ of experience crafting high-impact web solutions.",
  summary: "Front-End Developer with 13+ years of experience building scalable web applications, with a strong focus on JavaScript as the core of my development approach. Confident working across modern libraries and frameworks as Angular, and React. Skilled in Agile environments, UI/UX design, and AI-enhanced workflows. Known for clean code, a collaborative mindset, and delivering high-impact digital solutions.",
  technicalSkills: {
    languages: ["JavaScript (ES6+)", "HTML5", "CSS3", "SCSS"],
    frameworks: ["Angular", "React", "Svelte"],
    cms: ["Wordpress"],
    testing: ["Jest", "Jasmine", "Karma"],
    tools: ["Git", "Copilot", "Chat GPT", "Gemini"],
    methodologies: ["Agile", "Scrum"]
  },
  softSkills: [
    {
      title: "Communication",
      text: "Clear, concise, and bilingual (English/Spanish); skilled in translating technical concepts for diverse audiences."
    },
    {
      title: "Leadership",
      text: "Experience guiding cross-functional teams and mentoring junior developers in Agile environments."
    },
    {
      title: "Proactivity",
      text: "Self-driven and solution-oriented; anticipates challenges and takes initiative to resolve them."
    },
    {
      title: "Flexibility",
      text: "Adapts quickly to changing priorities, technologies, and team dynamics."
    },
    {
      title: "Mediation",
      text: "Effective at facilitating dialogue and resolving conflicts between stakeholders, designers, and developers."
    },
    {
      title: "English Proficiency",
      text: "Fluent in professional English with proven ability to communicate effectively across multicultural teams, ensuring clarity in complex d iscussions and documentation."
    }
  ],
  experience: [
    {
      company: "Globant",
      location: "Mexico City, Mexico",
      duration: "2017-2025",
      roles: [
        {
          title: "Front-End Developer",
          dates: "Jan 2024-Jul 2025",
          client: "Confidential (Global Biotech & Pharmaceutical Company)",
          techStack: {
            frontend: ["Angular (upgraded from v17 to v19)"],
            tools: ["Gemini AI"],
            purpose: "AI Extraction Pipeline — surface useful information extracted by AI tools processing PDFs"
          },
          details: [
            "Migrated enterprise apps from Angular 17 to 19, resolving complex dependencies.",
            "Integrated AI tools to streamline development and reduce debugging time.",
            "Collaborated with backend and AI teams to deliver responsive interfaces."
          ]
        },
        {
          title: "Front-End Developer",
          dates: "Apr 2023-Jan 2024",
          client: "Confidential (National Banking Group)",
          techStack: {
            frontend: ["Angular"],
            purpose: "Security library wrapper integration"
          },
          details: [
            "Developed a secure Angular wrapper library for enterprise-wide use.",
            "Delivered documentation and supported cross-team implementation."
          ]
        },
        {
          title: "Front-End Developer",
          dates: "May 2021 - Mar 2023",
          client: "Confidential (Digital Wealth Management Platform)",
          techStack: {
            frontend: ["React (primary for new components)"],
            legacy: ["Backbone.js", "jQuery"],
            purpose: "Maintain and enhance financial platform; introduce React components"
          },
          details: [
            "Maintained core features during integration of two financial platforms.",
            "Modernized legacy systems with React components in Backbone.js/jQuery.",
            "Designed data recovery strategies to improve user retention."
          ]
        },
        {
          title: "Front-End Developer",
          dates: "Oct 2019 - May 2021",
          client: "Confidential (Global Banking Institution)",
          techStack: {
            frontend: ["Svelte"],
            purpose: "Develop new components for regional adaptation of wealth management platform"
          },
          details: [
            "Built region-specific components for a wealth management platform using Svelte.",
            "Localized features for the Mexican market in collaboration with global teams."
          ]
        },
        {
          title: "Front-End Developer",
          dates: "Mar 2019 - Oct 2019",
          client: "Confidential (Wealth Management Firm)",
          techStack: {
            frontend: ["Angular 5+"],
            purpose: "CRM module development for wealth management"
          },
          details: [
            "Created a CRM module for financial services, enhancing broker workflows.",
            "Delivered scalable Angular components and post-launch optimizations."
          ]
        },
        {
          title: "Front-End Developer",
          dates: "Aug 2017 - Mar 2019",
          client: "Confidential (Global Investment Bank)",
          techStack: {
            frontend: ["Angular 2+, Ionic"],
            purpose: "Hybrid app support and mortgage module development"
          },
          details: [
            "Developed a mortgage module with interactive forms and visualizations.",
            "Resolved bugs in hybrid mobile apps (iOS/Android), improving reliability."
          ]
        }
      ]
    }
  ],
  earlyCareer: [
    {
      title: "Web & Mobile Developer / Project Manager",
      company: "OMAKASE Tech & Design",
      duration: "2015-2017",
      description: "Developed hybrid mobile apps (Yego, Tractostation, Comeralia) using Ionic and Angular for iOS/Android. Built custom WordPress websites from scratch. Managed government platform requirements as Project Manager for RUTY, bridging UX/UI design with backend development."
    },
    {
      title: "Webmaster",
      company: "MG Radio",
      duration: "2014-2015",
      description: "Developed custom WordPress websites from design specifications without using templates. Managed hosting services and performance optimization. Developed Facebook apps for social media campaigns and marketing initiatives."
    },
    {
      title: "Web & Mobile Developer",
      company: "Niumedia",
      duration: "2012-2014",
      description: "Developed hybrid mobile apps including Bride2be wedding planning app and Gasored gas station locator using Appgyver/Steroids, jQuery Mobile, and PhoneGap. First Angular.js project, progressing from UI/UX implementation to full feature development."
    }
  ],
  education: {
    institution: "Universidad Politécnica de San Luis Potosí",
    degree: "Bachelor of Engineering in Information Technology",
    graduation: "Dec 2014"
  }
};

export default resumeData